import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

const SAINTS = {
  '01-01':'Marie','01-02':'Basile','01-03':'Geneviève','01-04':'Odilon','01-05':'Édouard',
  '01-06':'Melchior','01-07':'Raymond','01-08':'Lucien','01-09':'Alix','01-10':'Guillaume',
  '01-11':'Paulin','01-12':'Tatiana','01-13':'Yvette','01-14':'Nina','01-15':'Rémi',
  '01-16':'Marcel','01-17':'Roseline','01-18':'Prisca','01-19':'Marius','01-20':'Sébastien',
  '01-21':'Agnès','01-22':'Vincent','01-23':'Barnard','01-24':'François de Sales','01-25':'Paul',
  '01-26':'Timothée','01-27':'Angèle','01-28':'Thomas d\'Aquin','01-29':'Gildas','01-30':'Martine','01-31':'Marcelle',
  '02-01':'Ella','02-02':'Présentation','02-03':'Blaise','02-04':'Véronique','02-05':'Agathe',
  '02-06':'Gaston','02-07':'Eugénie','02-08':'Jacqueline','02-09':'Apolline','02-10':'Arnaud',
  '02-11':'N-D de Lourdes','02-12':'Félix','02-13':'Béatrice','02-14':'Valentin','02-15':'Claude',
  '02-16':'Julienne','02-17':'Alexis','02-18':'Bernadette','02-19':'Gabin','02-20':'Aimée',
  '02-21':'Damien','02-22':'Isabelle','02-23':'Lazare','02-24':'Modeste','02-25':'Roméo',
  '02-26':'Nestor','02-27':'Honorine','02-28':'Romain','02-29':'Auguste',
  '03-01':'Aubin','03-02':'Charles le Bon','03-03':'Guénolé','03-04':'Casimir','03-05':'Olive',
  '03-06':'Colette','03-07':'Félicité','03-08':'Jean de Dieu','03-09':'Françoise','03-10':'Vivien',
  '03-11':'Rosine','03-12':'Justine','03-13':'Rodrigue','03-14':'Mathilde','03-15':'Louise',
  '03-16':'Bénédicte','03-17':'Patrick','03-18':'Cyrille','03-19':'Joseph','03-20':'Herbert',
  '03-21':'Clémence','03-22':'Léa','03-23':'Victorien','03-24':'Cath. de Suède','03-25':'Annonciation',
  '03-26':'Larissa','03-27':'Habib','03-28':'Gontran','03-29':'Gwladys','03-30':'Amédée','03-31':'Benjamin',
  '04-01':'Hugues','04-02':'Sandrine','04-03':'Richard','04-04':'Isidore','04-05':'Irène',
  '04-06':'Marcellin','04-07':'Jean-Baptiste de la Salle','04-08':'Julie','04-09':'Gautier','04-10':'Fulbert',
  '04-11':'Stanislas','04-12':'Jules','04-13':'Ida','04-14':'Maxime','04-15':'Paterne',
  '04-16':'Benoît-Joseph','04-17':'Anicet','04-18':'Parfait','04-19':'Emma','04-20':'Odette',
  '04-21':'Anselme','04-22':'Alexandre','04-23':'Georges','04-24':'Fidèle','04-25':'Marc',
  '04-26':'Alida','04-27':'Zita','04-28':'Valérie','04-29':'Catherine de Sienne','04-30':'Robert',
  '05-01':'Fête du Travail','05-02':'Boris','05-03':'Philippe','05-04':'Sylvain','05-05':'Judith',
  '05-06':'Prudence','05-07':'Gisèle','05-08':'Victoire 1945','05-09':'Pacôme','05-10':'Solange',
  '05-11':'Estelle','05-12':'Achille','05-13':'Rolande','05-14':'Matthias','05-15':'Denise',
  '05-16':'Honoré','05-17':'Pascal','05-18':'Éric','05-19':'Yves','05-20':'Bernardin',
  '05-21':'Constantin','05-22':'Rita','05-23':'Didier','05-24':'Donatien','05-25':'Sophie',
  '05-26':'Bérenger','05-27':'Augustin','05-28':'Germain','05-29':'Aymar','05-30':'Ferdinand','05-31':'Visitation',
  '06-01':'Justin','06-02':'Blandine','06-03':'Kévin','06-04':'Clotilde','06-05':'Igor',
  '06-06':'Norbert','06-07':'Gilbert','06-08':'Médard','06-09':'Diane','06-10':'Landry',
  '06-11':'Barnabé','06-12':'Guy','06-13':'Antoine de Padoue','06-14':'Élisée','06-15':'Germaine',
  '06-16':'J-F Régis','06-17':'Hervé','06-18':'Léonce','06-19':'Romuald','06-20':'Silvère',
  '06-21':'Rodolphe','06-22':'Alban','06-23':'Audrey','06-24':'Jean-Baptiste','06-25':'Prosper',
  '06-26':'Anthelme','06-27':'Fernand','06-28':'Irénée','06-29':'Pierre & Paul','06-30':'Martial',
  '07-01':'Thierry','07-02':'Martinien','07-03':'Thomas','07-04':'Florent','07-05':'Antoine',
  '07-06':'Mariette','07-07':'Raoul','07-08':'Thibaut','07-09':'Amandine','07-10':'Ulrich',
  '07-11':'Benoît','07-12':'Olivier','07-13':'Henri & Joël','07-14':'Fête Nationale','07-15':'Donald',
  '07-16':'N-D du Carmel','07-17':'Charlotte','07-18':'Frédéric','07-19':'Arsène','07-20':'Marina',
  '07-21':'Victor','07-22':'Marie-Madeleine','07-23':'Brigitte','07-24':'Christine','07-25':'Jacques',
  '07-26':'Anne & Joachim','07-27':'Nathalie','07-28':'Samson','07-29':'Marthe','07-30':'Juliette','07-31':'Ignace de Loyola',
  '08-01':'Alphonse','08-02':'Julien Eymard','08-03':'Lydie','08-04':'Jean-Marie Vianney','08-05':'Abel',
  '08-06':'Transfiguration','08-07':'Gaétan','08-08':'Dominique','08-09':'Amour','08-10':'Laurent',
  '08-11':'Claire','08-12':'Clarisse','08-13':'Hippolyte','08-14':'Evrard','08-15':'Assomption',
  '08-16':'Armel','08-17':'Hyacinthe','08-18':'Hélène','08-19':'Jean-Eudes','08-20':'Bernard',
  '08-21':'Christophe','08-22':'Fabrice','08-23':'Rose de Lima','08-24':'Barthélemy','08-25':'Louis',
  '08-26':'Natacha','08-27':'Monique','08-28':'Augustin','08-29':'Sabine','08-30':'Fiacre','08-31':'Aristide',
  '09-01':'Gilles','09-02':'Ingrid','09-03':'Grégoire','09-04':'Rosalie','09-05':'Raïssa',
  '09-06':'Bertrand','09-07':'Reine','09-08':'Nativité','09-09':'Alain','09-10':'Inès',
  '09-11':'Adelphe','09-12':'Apollinaire','09-13':'Aimé','09-14':'La Sainte Croix','09-15':'Roland',
  '09-16':'Édith','09-17':'Renaud','09-18':'Nadège','09-19':'Émilie','09-20':'Davy',
  '09-21':'Matthieu','09-22':'Maurice','09-23':'Constance','09-24':'Thècle','09-25':'Hermann',
  '09-26':'Côme & Damien','09-27':'Vinc. de Paul','09-28':'Venceslas','09-29':'Michel','09-30':'Jérôme',
  '10-01':'Thérèse de l\'Enfant-Jésus','10-02':'Léger','10-03':'Gérard','10-04':'François d\'Assise','10-05':'Fleur',
  '10-06':'Bruno','10-07':'Serge','10-08':'Pélagie','10-09':'Denis','10-10':'Ghislain',
  '10-11':'Firmin','10-12':'Wilfrid','10-13':'Géraud','10-14':'Juste','10-15':'Thérèse d\'Avila',
  '10-16':'Edwige','10-17':'Baudouin','10-18':'Luc','10-19':'René','10-20':'Adeline',
  '10-21':'Céline','10-22':'Élodie','10-23':'Jean de Capistran','10-24':'Florentin','10-25':'Crépin',
  '10-26':'Dimitri','10-27':'Émeline','10-28':'Simon & Jude','10-29':'Narcisse','10-30':'Bienvenu','10-31':'Quentin',
  '11-01':'Toussaint','11-02':'Défunts','11-03':'Hubert','11-04':'Charles','11-05':'Sylvie',
  '11-06':'Bertille','11-07':'Carine','11-08':'Geoffrey','11-09':'Théodore','11-10':'Léon',
  '11-11':'Martin','11-12':'Christian','11-13':'Brice','11-14':'Sidoine','11-15':'Albert',
  '11-16':'Marguerite','11-17':'Élisabeth','11-18':'Aude','11-19':'Tanguy','11-20':'Edmond',
  '11-21':'Prés. de Marie','11-22':'Cécile','11-23':'Clément','11-24':'Flora','11-25':'Catherine',
  '11-26':'Delphine','11-27':'Sévrin','11-28':'Jacques de la Marche','11-29':'Saturnin','11-30':'André',
  '12-01':'Florence','12-02':'Viviane','12-03':'François-Xavier','12-04':'Barbara','12-05':'Gérald',
  '12-06':'Nicolas','12-07':'Ambroise','12-08':'Immaculée Conception','12-09':'Pierre Fourier','12-10':'Romaric',
  '12-11':'Daniel','12-12':'Jeanne de Chantal','12-13':'Lucie','12-14':'Odile','12-15':'Ninon',
  '12-16':'Alice','12-17':'Gaël','12-18':'Gatien','12-19':'Urbain','12-20':'Abraham',
  '12-21':'Pierre Canisius','12-22':'Françoise-Xavière','12-23':'Armand','12-24':'Adèle','12-25':'Noël',
  '12-26':'Étienne','12-27':'Jean','12-28':'Saints Innocents','12-29':'David','12-30':'Roger','12-31':'Sylvestre',
};

function toISO(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; }
function todayMMDD() {
  const d = new Date();
  return `${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}
function getSaint(mmdd) { return SAINTS[mmdd] || ''; }

const MONTHS = ['jan','fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc'];

function daysUntilLabel(n) {
  if (n === 0) return { label: "Aujourd'hui ! 🎉", color: '#EF5350' };
  if (n === 1) return { label: 'Demain', color: '#FF9800' };
  if (n <= 7) return { label: `Dans ${n} jours`, color: '#6C63FF' };
  if (n <= 30) return { label: `Dans ${n} jours`, color: '#8888AA' };
  return { label: `Dans ${n} jours`, color: '#CCCCDD' };
}

export default function Birthdays() {
  const [birthdays, setBirthdays] = useState([]);
  const [members, setMembers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', day: '', month: '', related_user_id: '', notes: '' });

  const load = useCallback(() => {
    api.get('/birthdays').then(r => setBirthdays(r.data)).catch(console.error);
    api.get('/family/members').then(r => setMembers(r.data)).catch(console.error);
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew = () => {
    setForm({ name: '', day: '', month: '', related_user_id: '', notes: '' });
    setEditItem(null);
    setShowForm(true);
  };

  const openEdit = (b) => {
    const parts = b.birth_date.split('-');
    setForm({ name: b.name, day: String(parseInt(parts[2], 10)), month: parts[1], related_user_id: b.related_user_id || '', notes: b.notes || '' });
    setEditItem(b);
    setShowForm(true);
  };

  const save = async () => {
    if (!form.name.trim() || !form.day || !form.month) return;
    setSaving(true);
    try {
      const birth_date = `1900-${form.month}-${String(form.day).padStart(2, '0')}`;
      const payload = { name: form.name, birth_date, show_year: 0, related_user_id: form.related_user_id || null, notes: form.notes };
      if (editItem) await api.put(`/birthdays/${editItem.id}`, payload);
      else await api.post('/birthdays', payload);
      setShowForm(false);
      load();
    } catch (e) { alert(e.response?.data?.error || e.message); }
    setSaving(false);
  };

  const del = async () => {
    if (!editItem || !window.confirm(`Supprimer l'anniversaire de ${editItem.name} ?`)) return;
    await api.delete(`/birthdays/${editItem.id}`);
    setShowForm(false);
    load();
  };

  const wishBirthday = async (id, e) => {
    e.stopPropagation();
    try {
      await api.patch(`/birthdays/${id}/wish`);
      load();
    } catch (err) { alert(err.response?.data?.error || err.message); }
  };

  const saint = getSaint(todayMMDD());
  const today = toISO(new Date());
  const todayAndLate = birthdays.filter(b => b.days_until <= 0);
  const upcoming = birthdays.filter(b => b.days_until > 0 && b.days_until <= 30);
  const rest = birthdays.filter(b => b.days_until > 30);

  return (
    <div>
      <div className="topbar">
        <div className="page-title">🎂 Anniversaires & Fêtes</div>
        <button className="btn btn-primary btn-sm" onClick={openNew}>+ Ajouter</button>
      </div>

      <div className="page" style={{ paddingTop: 0 }}>

        {/* FÊTE DU JOUR */}
        <div style={{ background: 'linear-gradient(135deg, #6C63FF 0%, #A78BFA 100%)', borderRadius: 18, padding: '20px 20px', marginBottom: 16, color: 'white' }}>
          <div style={{ fontSize: 11, fontWeight: 700, opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>Aujourd'hui</div>
          <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 2 }}>
            🙏 Bonne fête {saint} !
          </div>
          <div style={{ fontSize: 13, opacity: 0.8 }}>
            {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
          </div>
        </div>

        {/* ANNIVERSAIRES AUJOURD'HUI ET EN RETARD */}
        {todayAndLate.map(b => {
          const late = b.days_until < 0;
          const bg = late
            ? 'linear-gradient(135deg, #FF9800, #FFB74D)'
            : 'linear-gradient(135deg, #FF6B6B, #FF9B9B)';
          const retardLabel = late
            ? ` (${Math.abs(b.days_until)} jour${Math.abs(b.days_until) > 1 ? 's' : ''} de retard)`
            : '';
          return (
            <div key={b.id} style={{ background: bg, borderRadius: 14, padding: '14px 16px', marginBottom: 12, color: 'white', display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontSize: 36 }}>{late ? '⏰' : '🎂'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 17, fontWeight: 800 }}>{late ? `Joyeux anniversaire ${b.name} !${retardLabel}` : `Joyeux anniversaire ${b.name} ! 🥳`}</div>
                {b.wished && <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>✓ Déjà souhaité</div>}
              </div>
              {!b.wished && (
                <button
                  onClick={e => wishBirthday(b.id, e)}
                  style={{ background: 'rgba(255,255,255,0.25)', color: 'white', border: '2px solid rgba(255,255,255,0.6)', borderRadius: 20, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}
                >✓ Souhaité</button>
              )}
            </div>
          );
        })}

        {/* DANS LES 30 JOURS */}
        {upcoming.length > 0 && (
          <>
            <div className="section-title">📅 À venir (30 jours)</div>
            {upcoming.map(b => {
              const { label, color } = daysUntilLabel(b.days_until);
              const member = members.find(m => m.id === b.related_user_id);
              const mmdd = b.birth_date.substring(5);
              return (
                <div key={b.id} onClick={() => openEdit(b)}
                  style={{ background: 'white', borderRadius: 14, padding: '14px 16px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.07)', cursor: 'pointer', borderLeft: `4px solid ${color}` }}>
                  <div style={{ fontSize: 28 }}>🎂</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#1A1A2E' }}>{b.name}</div>
                    <div style={{ fontSize: 12, color: '#8888AA', marginTop: 2 }}>
                      {new Date(b.next_birthday + 'T00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' })}
                      {member && <span style={{ marginLeft: 6 }}>· {member.avatar_emoji} {member.name}</span>}
                    </div>
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 700, color, textAlign: 'right', minWidth: 80 }}>{label}</div>
                </div>
              );
            })}
          </>
        )}

        {/* TOUS LES ANNIVERSAIRES */}
        {rest.length > 0 && (
          <>
            <div className="section-title" style={{ marginTop: 8 }}>🗓️ Tous les anniversaires</div>
            {rest.map(b => {
              const member = members.find(m => m.id === b.related_user_id);
              return (
                <div key={b.id} onClick={() => openEdit(b)}
                  style={{ background: 'white', borderRadius: 12, padding: '12px 16px', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 1px 6px rgba(0,0,0,0.05)', cursor: 'pointer' }}>
                  <span style={{ fontSize: 22 }}>🎂</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{b.name}</div>
                    <div style={{ fontSize: 12, color: '#8888AA' }}>
                      {new Date(b.next_birthday + 'T00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' })}
                      {member && <span style={{ marginLeft: 6 }}>· {member.avatar_emoji} {member.name}</span>}
                    </div>
                  </div>
                  <div style={{ fontSize: 12, color: '#BBBBCC' }}>dans {b.days_until}j</div>
                </div>
              );
            })}
          </>
        )}

        {birthdays.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🎂</div>
            <div className="empty-text">Aucun anniversaire enregistré<br />Ajoutez vos proches !</div>
            <button className="btn btn-primary btn-sm" style={{ marginTop: 12 }} onClick={openNew}>+ Ajouter</button>
          </div>
        )}
      </div>

      {/* MODAL AJOUT / ÉDITION */}
      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">{editItem ? '✏️ Modifier' : '🎂 Nouvel anniversaire'}</div>

            <div className="form-group">
              <label className="form-label">Prénom / Nom</label>
              <input className="form-input" placeholder="Ex: Grand-mère Michèle" value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })} autoFocus />
            </div>

            <div className="form-group">
              <label className="form-label">Date de naissance</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <select className="form-input" value={form.day} onChange={e => setForm({ ...form, day: e.target.value })} style={{ flex: 1 }}>
                  <option value="">Jour</option>
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
                <select className="form-input" value={form.month} onChange={e => setForm({ ...form, month: e.target.value })} style={{ flex: 2 }}>
                  <option value="">Mois</option>
                  {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m, i) => (
                    <option key={m} value={m}>{['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'][i]}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Membre de la famille (optionnel)</label>
              <select className="form-input" value={form.related_user_id}
                onChange={e => setForm({ ...form, related_user_id: e.target.value })}>
                <option value="">— Aucun (contact extérieur) —</option>
                {members.map(m => <option key={m.id} value={m.id}>{m.avatar_emoji} {m.name}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Note (optionnel)</label>
              <input className="form-input" placeholder="Ex: appeler, envoyer cadeau..." value={form.notes}
                onChange={e => setForm({ ...form, notes: e.target.value })} />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              {editItem && <button className="btn btn-danger btn-sm" onClick={del}>🗑️</button>}
              <button className="btn btn-ghost" onClick={() => setShowForm(false)} style={{ flex: 1 }}>Annuler</button>
              <button className="btn btn-primary" onClick={save} disabled={saving || !form.name.trim() || !form.day || !form.month} style={{ flex: 2 }}>
                {saving ? <span className="spinner" style={{ width: 16, height: 16 }} /> : '✓ Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
